// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"6a8471cf","371":"95c08e72","390":"b87648d4","644":"d09189be","669":"a8799af8","839":"2e28029f"}[chunkId] + ".chunk.js";
};